import { useMutation, useQueryClient } from '@tanstack/react-query';
import { setOnboardingAnswers } from 'shared/services/local-storage';
import { OnboardingAnswers } from 'shared/types/onboarding-answers';

import { queryKey } from './use-onboarding-answers-query';

export const useUpdateOnboardingAnswersMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (onboardingAnswers: Partial<OnboardingAnswers>) => {
      setOnboardingAnswers(onboardingAnswers);
      await queryClient.invalidateQueries({ queryKey: [queryKey] });
    },
  });
};
